import i18n from '@/plugins/i18n';
import * as types from '@/components/Database/database.types';
const hardwareMSGraphs = () => ({
  lineCharts: [
    {
      width: '49%',
      header: {
        title: i18n.global.t('dbm.cpuUsage'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#F7507F', '#059379', '#FDFCAC', '#FFFFFF'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'LABELED_VALUE',
      metricName: 'meter_mssql_cpu_usage',
      queryMetricType: 'readLabeledMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.percentage'),
      },
      show: true,
      showForSingleSeries: true,
      showMetricDropdown: true,
      showmetricRate: true,
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('dbm.memoryUsage'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#F7507F', '#059379', '#FDFCAC', '#FFFFFF'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'LABELED_VALUE',
      metricName: 'meter_mssql_memory_usage',
      queryMetricType: 'readLabeledMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.mb'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1048576',
      showMetricDropdown: true,
      showmetricRate: true,
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('dbm.networkI/O'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#abc0ff', '#1fb4ff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'LABELED_VALUE',
      metricName: 'meter_network_packet_size',
      queryMetricType: 'readLabeledMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.mb'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1048576',
      showMetricDropdown: true,
      showmetricRate: true,
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('dbm.hardware.diskUsage'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#F7507F', '#059379', '#FDFCAC', '#FFFFFF'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'LABELED_VALUE',
      metricName: 'meter_disk_usage',
      queryMetricType: 'readLabeledMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.mb'),
      },
      showLegendForSeries: true,
      showMetricDropdown: true,
      showmetricRate: true,
      aggregation: '/',
      aggregationNum: '1048576',
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('dbm.total-bytes-read'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#F7507F', '#059379', '#FDFCAC', '#FFFFFF'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'LABELED_VALUE',
      metricName: 'meter_total_bytes_read',
      queryMetricType: 'readLabeledMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.mb'),
      },
      aggregation: '/',
      aggregationNum: '1048576',
      showLegendForSeries: true,
      showMetricDropdown: true,
      showmetricRate: true,
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('dbm.total-bytes-write'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#F7507F', '#059379', '#FDFCAC', '#FFFFFF'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'LABELED_VALUE',
      metricName: 'meter_total_bytes_written',
      queryMetricType: 'readLabeledMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.mb'),
      },
      aggregation: '/',
      aggregationNum: '1048576',
      showLegendForSeries: true,
      showMetricDropdown: true,
      showmetricRate: true,
    },
  ],
  cardComponents: {
    width: '20%',
    clusterCardsName: [
      i18n.global.t('dbm.card.loadAverage'),
      i18n.global.t('dbm.card.host'),
      i18n.global.t('dbm.card.port'),
      i18n.global.t('dbm.card.role'),
      i18n.global.t('dbm.card.status'),
    ],
    clusterCardNamesMap: {
      [types.mssqlClusterCardNames.LOAD_AVG]:
        types.mssqlClusterCardValues.LOAD_AVG,
      [types.mssqlClusterCardNames.PORT]: types.mssqlClusterCardValues.PORT,
      [types.mssqlClusterCardNames.HOST]: types.mssqlClusterCardValues.HOST,
      [types.mssqlClusterCardNames.ROLE]: types.mssqlClusterCardValues.ROLE,
      [types.mssqlClusterCardNames.STATUS]: types.mssqlClusterCardValues.STATUS,
    },
  },
});

export default hardwareMSGraphs;
